import type { User } from "@supabase/supabase-js";

export const ADMIN_ROLE = "admin" as const;
export const EDITOR_ROLE = "editor" as const;

export const STAFF_ROLES = [ADMIN_ROLE, EDITOR_ROLE] as const;

export type AdminRole = typeof ADMIN_ROLE;
export type StaffRole = (typeof STAFF_ROLES)[number];

export type TeamMemberRole = "ADMIN" | "EDITOR";

export function teamMemberRoleToStaffRole(
  role: TeamMemberRole,
): StaffRole {
  return role === "ADMIN" ? ADMIN_ROLE : EDITOR_ROLE;
}

export function normalizeStaffRole(
  role: string | undefined,
): StaffRole | undefined {
  if (!role) {
    return undefined;
  }

  const normalized = role.trim().toLowerCase();

  if (normalized === ADMIN_ROLE || normalized === EDITOR_ROLE) {
    return normalized as StaffRole;
  }

  return undefined;
}

export function getUserRole(
  user: User | null | undefined,
): StaffRole | undefined {
  const role = user?.app_metadata?.role;
  return typeof role === "string" ? normalizeStaffRole(role) : undefined;
}

export function isStaffUser(user: User | null | undefined): boolean {
  return getUserRole(user) !== undefined;
}

export function isAdminUser(user: User | null | undefined): boolean {
  return getUserRole(user) === ADMIN_ROLE;
}

export const MUST_SET_PASSWORD_KEY = "whart:must-set-password";

export function markMustSetPassword(): void {
  sessionStorage.setItem(MUST_SET_PASSWORD_KEY, "1");
}

export function clearMustSetPassword(): void {
  sessionStorage.removeItem(MUST_SET_PASSWORD_KEY);
}

export function mustSetPassword(): boolean {
  return sessionStorage.getItem(MUST_SET_PASSWORD_KEY) === "1";
}
